import React, { Component } from "react"
import { connect } from "react-redux"
import { translate } from "react-translate"
import { Link } from "react-router-dom"
import {
  Segment,
  Form,
  Label,
  Container,
  TextArea,
  Grid,
  Dropdown,
  Input,
  Button,
  Icon
} from "semantic-ui-react"
import "./ParametreDocument.css"
import _ from "lodash"

const options = [
  { key: 1, text: "value_dropdown_5mois", value: 1 },
  { key: 2, text: "value_dropdown_6mois", value: 2 }
]

const mapStateToProps = state => ({
  app: state.app
})

class ConnectedParametreDocument extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  componentWillMount() {
    let { t } = this.props
    var optionsCopy = _.clone(options)
    optionsCopy = _.map(optionsCopy, x => {
      return {
        ...x,
        text: t(x.text)
      }
    })

    this.setState({
      options: optionsCopy
    })
  }

  handleChange = (e, { value }) => this.setState({ value })

  render() {
    let { t } = this.props
    const { value } = this.state
    return (
      <Container id="containerForm" fluid>
        <Segment as="h3" size="huge" basic className="titleSegment">
          {t("title_specifique_devis")}
        </Segment>

        <Segment>
          <Form>
            <Grid>
              <Grid.Row>
                <Grid.Column computer={10} tablet={16} mobile={16}>
                  <Form.Field>
                    <Label className="labelInForm">
                      {t("label_note_fin_devis_defaut")}
                    </Label>
                    <Form.Field
                      id="form-textarea-control-opinion"
                      fluid
                      control={TextArea}
                      placeholder={t("placeholder_montant_révisé")}
                    />
                  </Form.Field>
                </Grid.Column>
                <Grid.Column computer={6} tablet={16} mobile={16}>
                  <Form.Group>
                    <Form.Field>
                      <Label className="labelForms">
                        {t("label_duré_validité_devis")}
                      </Label>
                      <Dropdown
                        className="dropdownForm"
                        search
                        selection
                        wrapSelection={false}
                        options={this.state.options || []}
                        placeholder={t("placeholder_dropdown_mois")}
                      />
                    </Form.Field>
                  </Form.Group>
                  <Form.Group>
                    <Form.Field>
                      <Label className="labelForms">
                        {t("label_name_signature")}
                      </Label>
                      <Form.Input
                        className="dropdownForm"
                        placeholder="Warren Sanders"
                      />
                    </Form.Field>
                  </Form.Group>
                  <Form.Group>
                    <Form.Field>
                      <Label className="labelForms">
                        {t("label_numerotation_devis")}
                      </Label>
                      <Button id="buttonParametre">
                        <Icon
                          name="pencil"
                          color="white"
                          className="actionIcon"
                          onClick={() => {}}
                        />
                        {t("button_modif_numerotation_devis")}
                      </Button>
                    </Form.Field>
                  </Form.Group>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>
        </Segment>
        <Segment as="h3" size="huge" basic className="titleSegment">
          {t("title_specifique_facture")}
        </Segment>
        <Segment>
          <Form>
            <Grid>
              <Grid.Row>
                <Grid.Column computer={10} tablet={10} mobile={16}>
                  <Form.Field>
                    <Label className="labelInForm">
                      {t("label_note_fin_facture_defaut")}
                    </Label>
                    <Form.Field
                      id="form-textarea-control-opinion"
                      control={TextArea}
                      placeholder={t("placeholder_montant_révisé_facture")}
                    />
                  </Form.Field>
                </Grid.Column>
                <Grid.Column computer={6} tablet={6} mobile={16}>
                  <Form.Group>
                    <Form.Field>
                      <Label id="devisNumber">
                        {t("label_numerotation_facture")}
                      </Label>
                      <Button id="numerotationButton">
                        <Icon
                          name="pencil"
                          color="white"
                          className="actionIcon"
                          onClick={() => {}}
                        />
                        {t("button_modif_numerotation_facture")}
                      </Button>
                    </Form.Field>
                  </Form.Group>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>
        </Segment>
        <Segment as="h3" size="huge" basic className="titleSegment">
          {t("title_mean_of_payment")}
        </Segment>
        <Segment id="bottomSegment">
          <Form.Group inline id="radioButton">
            <Button className="moyenPaiementButton">
              <Form.Radio
                label={t("label_button_radio_espece")}
                value="sm"
                checked={value === "sm"}
                onChange={this.handleChange}
              />
            </Button>
            <Button className="moyenPaiementButton">
              <Form.Radio
                label={t("label_button_radio_cheque")}
                value="md"
                checked={value === "md"}
                onChange={this.handleChange}
              />
            </Button>
            <Button className="moyenPaiementButton">
              <Form.Radio
                label={t("label_button_radio_virement")}
                value="lg"
                checked={value === "lg"}
                onChange={this.handleChange}
              />
            </Button>
            <Button className="moyenPaiementButton">
              <Form.Radio
                label={t("label_button_radio_blueCard")}
                value="lg"
                checked={value === "lg"}
                onChange={this.handleChange}
              />
            </Button>
          </Form.Group>
        </Segment>
      </Container>
    )
  }
}

const ParametreDocument = connect(mapStateToProps)(ConnectedParametreDocument)
export default translate("ProParametreDocument")(ParametreDocument)



// WEBPACK FOOTER //
// ./src/components/Pro/Parametres/DocumentDevisFacture/ParametreDocument.jsx